/**
 * Por: Daniel Cedraz
 * Serviço responsável por expor variáveis de ambiente carregadas via env.js.
 * Este serviço lê valores dinâmicos definidos no runtime (Cloud Run).
 */

import { Injectable } from '@angular/core';
import { EnvModel } from './env.model';

@Injectable({ providedIn: 'root' })
export class EnvFeatureService {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
  private env = ((window as any).__env as EnvModel) || {};

  public apiBaseUrl: string = '';
  public ambiente: string = 'development';
  public livAuthBaseUrl: string = '';
  public livAppId: string = '';

  constructor() {
    this.apiBaseUrl = this.env.apiBaseUrl;
    this.ambiente = this.env.ambiente;
    this.livAuthBaseUrl = this.env.livAuthBaseUrl ?? '';
    this.livAppId = this.env.livAppId ?? '';
  }
}
